/* istanbul ignore file */
import BigFormRow from '../../ui/layout/form/FormRow/BigFormRow';
import FormRow from '../../ui/layout/form/FormRow/FormRow';
import MediumFormRow from '../../ui/layout/form/FormRow/MediumFormRow';

export enum FormRowType {
  DEFAULT = 'default',
  BIG = 'big',
  MEDIUM = 'medium',
}

type FormRowProps = {
  type: FormRowType;
  children: any;
  props: any;
};

const FormRowFactory = ({ type, children, props }: FormRowProps) => {
  switch (type) {
    case FormRowType.DEFAULT:
      return <FormRow {...props}>{children}</FormRow>;
    case FormRowType.BIG:
      return <BigFormRow {...props}>{children}</BigFormRow>;
    case FormRowType.MEDIUM:
      return <MediumFormRow {...props}>{children}</MediumFormRow>;
    default:
      return <></>;
  }
};

export default FormRowFactory;
